export default "__VITE_ASSET__696035f6__"